import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Experiments = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="experiments-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.2776 3.58943C7.2776 3.14901 7.63463 2.79198 8.07505 2.79198H15.925C16.3654 2.79198 16.7224 3.14901 16.7224 3.58943C16.7224 4.02985 16.3654 4.38688 15.925 4.38688H15.601V8.96012L17.6505 12.1133C17.6565 12.1222 17.6624 12.1312 17.668 12.1403L20.5088 16.5109C20.8071 16.9697 20.9759 17.5006 20.9976 18.0474C21.0193 18.5942 20.893 19.1368 20.632 19.6178C20.371 20.0988 19.9849 20.5005 19.5147 20.7804C19.0444 21.0603 18.5073 21.2081 17.96 21.2081H6.03592C5.489 21.2073 4.95241 21.059 4.48271 20.7788C4.01301 20.4986 3.6276 20.0969 3.36708 19.616C3.10656 19.1351 2.98058 18.5929 3.00243 18.0464C3.02427 17.4999 3.19313 16.9694 3.4912 16.5109L6.33199 12.1403C6.33764 12.1312 6.34347 12.1222 6.34947 12.1134L8.39901 8.96011V4.38688H8.07505C7.63463 4.38688 7.2776 4.02985 7.2776 3.58943ZM9.99391 4.38688V9.1965C9.99391 9.35078 9.94916 9.50174 9.86509 9.63109L8.47921 11.7633H15.5208L14.1349 9.63109C14.0508 9.50174 14.0061 9.35078 14.0061 9.1965V4.38688H9.99391ZM16.5574 13.3582H7.44256L4.82844 17.3801C4.68673 17.5981 4.60644 17.8503 4.59606 18.1101C4.58567 18.3699 4.64556 18.6277 4.76941 18.8563C4.89327 19.0849 5.0765 19.2759 5.2998 19.4091C5.5231 19.5423 5.77819 19.6128 6.03821 19.6132H17.9599C17.9599 19.6132 17.9598 19.6132 17.9599 19.6132C18.22 19.6132 18.4754 19.5429 18.699 19.4099C18.9225 19.2768 19.106 19.0858 19.2301 18.8572C19.3542 18.6285 19.4143 18.3706 19.404 18.1106C19.3937 17.8506 19.3134 17.5982 19.1716 17.3801L16.5574 13.3582Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
